var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-3"},[_c('h1',[_vm._v("Player Analysis")]),_c('p',[_vm._v(" See how you or other players have been playing recently ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }